import React, { useEffect, useRef, useState } from "react";
import { ArrowLink } from "../ArrowLink";
import Divider from "molecules/SimpleBorder/Divider";

export const ArrowListing = (props) => {
  const defaultColor = '#000';
  const defaultFont = 'EB Garamond';
  const defaultFontSize = '26px'
  const [isVisible, setIsVisible] = useState(false);
  const borderRef = useRef(null);
    
useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect(); // Stop observing after visibility
      }
    },
    { threshold: 0.1 } // Trigger when 10% is visible
  );

  if (borderRef.current) {
    observer.observe(borderRef.current);
  }

  return () => {
    if (borderRef.current) {
      observer.unobserve(borderRef.current);
    }
  };
}, []);


  return (
    <ul className={`listing border-listing arrow-listing ${props.className}`}>
 <style>
      {`
          @keyframes widthIncrease {
            from {
              width: 10%;
            }
            to {
              width: 100%;
            }
          }

          .animated-border {
            height: 1px; /* Adjust height as needed */
            background-color: black; /* Change this if you want a different color */
            transition: width 0.5s; /* Optional: smooth transition */
          }

          .animated {
            animation: widthIncrease 2s forwards; /* Adjust duration as needed */
          }
        `}
      </style>


      
      {props.data
        ? props.data.map((item, index) => (
            <li data-aos="fade-up " className=" "
           >
              <div className="grid align-items-center"   >
                <div className="col-10  pl-0">
                  <h3 className="font-medium mt-0  pb-2" style={{color:props.color || defaultColor , fontFamily:props.font || defaultFont, fontWeight:'bold !important' , fontSize: props.fontSize || defaultFontSize}}>{item.listtitle}</h3>
                  <p className="details-text pb-1" style={{fontSize:'17px'}}>{item.listdetail}</p>
                </div>
                {/* <div className="col-2 flex justify-content-end  ">
                  {item.listlink && (
                    <ArrowLink
           
                      url={item.listlink}
                      className="bg-tranper border-1 border-black-700"
                    />
                  )}
                </div> */}
                <Divider/>

               
                      {/* <div
              ref={borderRef}
              className={`  animated-border ${isVisible ? "animated" : ""}`}
              style={{ width: isVisible ? "100%" : "10%" }} // Initial width based on visibility
            ></div> */}
              </div>
            </li>
          ))
        : "Loading..."}
    </ul>
  );
};
